import classnames from 'classnames/bind'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'
import {
  hooks,
  ChatButton,
  chatUtils,
  FeatureFlags,
  AuctionApplication,
  ProductLine,
  LogoHeader,
} from '@adc/ui-adc'
import configment from '@adc/configment'
import styles from './styles.scss'
import SellerFlowRoutes from './sellerFlowRoutes'

const cx = classnames.bind(styles)

type PrivateSellerFormProps = {
  match: Record<string, any>
  featureFlags: FeatureFlags
  user: any
  initialLeadData: {
    address: Record<string, string>
  }
  initialLeadValidations?: Record<string, string>
}

const PrivateSellerForm = ({
  match,
  featureFlags,
  user,
  initialLeadData,
  initialLeadValidations,
}: PrivateSellerFormProps) => {
  const history = useHistory()
  const isMounted = hooks.useIsMounted()
  const capabilities = {
    surveyMonkey: { enabled: false },
    pageTracking: {
      enabled: true,
      options: {
        domainEvents: true,
      },
    },
  }
  const helmetConfig = {
    title: '',
  }
  return (
    <AuctionApplication
      user={user}
      featureFlags={featureFlags}
      sspConfig={configment.get()}
      helmetConfig={helmetConfig}
      capabilities={capabilities}
      overridableComponents={{ header: <LogoHeader isSticky /> }}
      // @ts-ignore
      theme={{ productLine: ProductLine.SmartSale }}
      history={history}
    >
      <div className={cx('container')}>
        <ChatButton variant={chatUtils?.ChatVariants.Concierge} />
        {isMounted && (
          <SellerFlowRoutes
            featureFlags={featureFlags}
            initialLeadData={initialLeadData}
            // @ts-ignore match is from react-router and has to be passed down for routing to work but is not typed correctly
            match={match}
            initialLeadValidations={initialLeadValidations}
          />
        )}
      </div>
    </AuctionApplication>
  )
}
const mapStateToProps = (store: any) => {
  return {
    user: store.user,
    form: store.form,
    featureFlags: store.featureFlags,
    initialLeadData: store.initialLeadData,
    initialLeadValidations: store.initialLeadValidations,
  }
}

export default connect(mapStateToProps)(PrivateSellerForm)
